import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
export function useSearchPage() {
    const started = useRef(true);
    const history = useHistory();
    const loc = useLocation();
    const initialState = Object.assign({ search: "", page: 1 }, loc.state);
    const [newState, setNewState] = useState(initialState);
    const changePage = (page) => {
        window.scrollTo(0, 0);
        history.replace({
            state: Object.assign(Object.assign({}, history.location.state), { page }),
            hash: history.location.hash,
            search: history.location.search,
        });
    };
    useEffect(() => {
        if (!started.current && initialState.search !== newState.search) {
            if (initialState.page !== 1) {
                changePage(1);
            }
            else {
                setNewState(initialState);
            }
        }
    }, [initialState.search]);
    useEffect(() => {
        if (!started.current && initialState.page !== newState.page) {
            setNewState(initialState);
        }
    }, [initialState.page]);
    useEffect(() => {
        started.current = false;
    }, []);
    return [newState.search, newState.page, changePage];
}
//# sourceMappingURL=useSearchPage.js.map